import { c as _c } from "react/compiler-runtime";
import { motion } from "framer-motion";
export default function CreateWavesMainStepConnectionLine(t0) {
  const $ = _c(7);
  const {
    done
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="tw-absolute tw-right-[11px] tw-top-9 tw-h-full tw-w-0.5 tw-rounded-sm tw-bg-iron-700" aria-hidden="true" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = done ? 1 : 0;
  let t3;
  if ($[1] !== t2) {
    t3 = {
      scaleY: t2
    };
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      duration: 0.5
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      originY: 0,
      scaleY: 0
    };
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t3) {
    t6 = <div>{t1}<motion.div initial={false} animate={t3} transition={t4} className="tw-absolute tw-right-[11px] tw-top-9 tw-h-full tw-w-0.5 tw-rounded-sm tw-bg-primary-500" style={t5} aria-hidden="true" /></div>;
    $[5] = t3;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
}